import { DateTime } from "luxon";

export const useDateCalculations = () => {
    const now = DateTime.now();

    const today = now.toISODate();
    const tomorrow = now.plus({ days: 1 }).toISODate();
    const thisWeek = now.toFormat("kkkk-WW");
    const thisMonth = now.toFormat("yyyy-MM");

    return {
        today,
        tomorrow,
        thisWeek,
        thisMonth,
    };
};
